import {DispatchedTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCheckbox} from "@tabler/icons-react";

type Props = {
  event: DispatchedTimelineEvent;
};

export const DispatchedTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.dispatch.timeline.dispatched.title", "Dispatched")}</>
}

export const DispatchedTimelineItemBullet = (props: {}) => {
  return (
    <ThemeIcon
      size={22}
      color="dispatch-pending"
      radius="xl"
    >
      <IconCheckbox size={12}/>
    </ThemeIcon>
  )
}

export const DispatchedTimelineItem = (props: Props) => {
  const {event} = props;

  const {t} = useTranslation(["common"])

  return (
    <>
      <Text color="dimmed" size="sm">
        {t("common.entity.dispatch.timeline.dispatched.summary", "{{personName}} created the dispatch.", {
          personName: event.person ?? event.company ?? t("common.shared.user", "User")
        })}
      </Text>

      <Text size="xs" mt={4}>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

DispatchedTimelineItem.Title = DispatchedTimelineItemTitle
DispatchedTimelineItem.Bullet = DispatchedTimelineItemBullet;
